export default "__VITE_ASSET__4287e20f__"